// Small shared helpers. RustDesk zstd-compresses cursor pixels and clipboard;
// fzstd is a tiny pure-JS zstd decompressor.
import { decompress as zstd } from "fzstd";

export function decompress(data: Uint8Array): Uint8Array {
  try {
    return zstd(data);
  } catch (e) {
    console.error("[zstd] decompress failed", e);
    return new Uint8Array(0);
  }
}
